/**
 * Set an item in local storage.
 * This function now explicitly accepts an object or string.
 */
export const setLocalStorageItem = (key: string, value: object | string) => {
  try {
    const stringValue = typeof value === 'object' ? JSON.stringify(value) : value;
    window.localStorage.setItem(key, stringValue);
  } catch (error) {
    console.error(`Error saving ${key} in localStorage`, error);
  }
};

/**
 * Get an item from local storage.
 * Automatically parses JSON strings back into objects.
 */
export const getLocalStorageItem = async <T = any>(key: string): Promise<T | null> => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error getting ${key} from localStorage`, error);
    return null;
  }
};

/**
 * Remove an item from local storage.
 */
export const removeLocalStorageItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing ${key} from localStorage`, error);
  }
};

/**
 * Check if a key exists in local storage.
 */
export const hasLocalStorageKey = (key: string): boolean => {
  return window.localStorage.getItem(key) !== null;
};
